__turbopack_context__.v({
  "active": "NavigationListItem-module-scss-module__KDL_Ka__active",
  "button": "NavigationListItem-module-scss-module__KDL_Ka__button",
  "depth1": "NavigationListItem-module-scss-module__KDL_Ka__depth1",
  "expanded": "NavigationListItem-module-scss-module__KDL_Ka__expanded",
  "icon": "NavigationListItem-module-scss-module__KDL_Ka__icon",
  "link": "NavigationListItem-module-scss-module__KDL_Ka__link",
  "navigationListItem": "NavigationListItem-module-scss-module__KDL_Ka__navigationListItem",
  "nestedNavigationList": "NavigationListItem-module-scss-module__KDL_Ka__nestedNavigationList",
  "subpointIcon": "NavigationListItem-module-scss-module__KDL_Ka__subpointIcon",
});
